import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { SubTabs } from 'shared/components';
import COD_STATUS_QUERY, { CodStatusData } from 'shared/graphql/query/codStatus';
import { CodInStatus } from 'views/CashOnDelivery/Routes/CashOnDeliveryByBooking/common/model/codInStatus.model';

interface CodInListTabsProps {
  name: string;
  tab: CodInStatus;
  onChange: (tab: CodInStatus) => void;
}

const CodInListTabs: React.FC<CodInListTabsProps> = (props) => {
  const { tab, onChange, name } = props;
  const { data, refetch } = useQuery<CodStatusData>(COD_STATUS_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const checkSelectTab = (id: CodInStatus) => {
    return id === tab && name === 'cod';
  };

  const selectTab = (index: CodInStatus) => {
    refetch();
    onChange(index);
  };

  const tabs = [
    {
      id: CodInStatus.PENDING,
      name: 'รอตรวจ COD',
      color: 'badge-grey',
      count: data?.codStatus.pending || 0,
      divider: false,
    },
    {
      id: CodInStatus.WAITING,
      name: 'รอจ่าย COD',
      color: 'badge-grey',
      count: data?.codStatus.waiting || 0,
      divider: false,
    },
    {
      id: CodInStatus.CONFIRM,
      name: 'สั่งจ่ายแล้ว',
      color: 'badge-grey',
      count: data?.codStatus.confirm || 0,
      divider: false,
    },
  ].map((item) => ({
    id: item.id,
    name: item.name,
    count: item.count,
    active: checkSelectTab(item.id),
    clicked: () => selectTab(item.id),
    badgeClassName: checkSelectTab(item.id) ? item.color : null,
    divider: item.divider,
  }));

  return <SubTabs tabs={tabs} />;
};

export default CodInListTabs;
